/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Remove_Child_TitleInputs */



/**
* | output |
* | --- |
* | "Remove from meta-league" |
*
* @param {League_Remove_Child_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_remove_child_title = /** @type {((inputs?: League_Remove_Child_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Remove_Child_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retirer de la méta-ligue")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar de la meta-liga")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Remover da meta-liga")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi dal meta-campionato")
	return /** @type {LocalizedString} */ ("Remove from meta-league")
});